var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { EmailAlertStatusApi } from '../apis/email-alert-status-api';
let EmailAlertStatusServiceRepository = class EmailAlertStatusServiceRepository {
    constructor(_emailAlertStatusApi) {
        this._emailAlertStatusApi = _emailAlertStatusApi;
    }
    getFolderEmailAlertStatus(folderId) {
        return this._emailAlertStatusApi.getFolderEmailAlertStatusApi(folderId).then((res) => {
            return res.length > 0;
        });
    }
};
EmailAlertStatusServiceRepository = __decorate([
    injectable(),
    __param(0, inject(EmailAlertStatusApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof EmailAlertStatusApi !== "undefined" && EmailAlertStatusApi) === "function" ? _a : Object])
], EmailAlertStatusServiceRepository);
export { EmailAlertStatusServiceRepository };
